import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

function buildPrescriptionFunctionUrl(id: string, code: string) {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  if (!supabaseUrl) return null;

  const origin = supabaseUrl.replace(/\/$/, "");
  return `${origin}/functions/v1/prescription-pdf-download/prescricao/${id}/arquivo/${encodeURIComponent(code)}.pdf`;
}

export default function PrescriptionPdfRedirect() {
  const { t } = useTranslation("common");
  const { id = "", code = "" } = useParams<{ id: string; code: string }>();

  useEffect(() => {
    const target = buildPrescriptionFunctionUrl(id, code);
    if (!target) return;
    window.location.replace(target);
  }, [code, id]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="flex items-center gap-3 text-sm text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span>{t("loading")}</span>
      </div>
    </div>
  );
}
